
import { WorldCity } from '../types';

// Expansión de Bulgaria - 75 ciudades adicionales
export const bulgariaAdditionalCities: WorldCity[] = [
  { name: 'Plovdiv', slug: 'plovdiv', population: 346893 },
  { name: 'Varna', slug: 'varna', population: 335177 },
  { name: 'Burgas', slug: 'burgas', population: 202694 },
  { name: 'Ruse', slug: 'ruse', population: 144936 },
  { name: 'Stara Zagora', slug: 'stara-zagora', population: 138272 },
  { name: 'Pleven', slug: 'pleven', population: 106954 },
  { name: 'Sliven', slug: 'sliven', population: 91620 },
  { name: 'Dobrich', slug: 'dobrich', population: 85402 },
  { name: 'Shumen', slug: 'shumen', population: 80855 },
  { name: 'Pernik', slug: 'pernik', population: 76422 },
  { name: 'Haskovo', slug: 'haskovo', population: 74172 },
  { name: 'Yambol', slug: 'yambol', population: 72959 },
  { name: 'Pazardzhik', slug: 'pazardzhik', population: 71979 },
  { name: 'Blagoevgrad', slug: 'blagoevgrad', population: 70881 },
  { name: 'Veliko Tarnovo', slug: 'veliko-tarnovo', population: 68783 },
  { name: 'Vratsa', slug: 'vratsa', population: 60482 },
  { name: 'Gabrovo', slug: 'gabrovo', population: 58950 },
  { name: 'Asenovgrad', slug: 'asenovgrad', population: 50846 },
  { name: 'Vidin', slug: 'vidin', population: 47332 },
  { name: 'Kazanlak', slug: 'kazanlak', population: 47698 },
  { name: 'Kyustendil', slug: 'kyustendil', population: 44532 },
  { name: 'Montana', slug: 'montana', population: 43462 },
  { name: 'Dimitrovgrad', slug: 'dimitrovgrad', population: 38015 },
  { name: 'Targovishte', slug: 'targovishte', population: 35053 },
  { name: 'Lovech', slug: 'lovech', population: 34548 },
  { name: 'Silistra', slug: 'silistra', population: 35607 },
  { name: 'Razgrad', slug: 'razgrad', population: 33238 },
  { name: 'Dupnitsa', slug: 'dupnitsa', population: 30386 },
  { name: 'Gorna Oryahovitsa', slug: 'gorna-oryahovitsa', population: 30239 },
  { name: 'Kardzhali', slug: 'kardzhali', population: 43880 },
  { name: 'Velingrad', slug: 'velingrad', population: 22602 },
  { name: 'Nova Zagora', slug: 'nova-zagora', population: 23625 },
  { name: 'Berkovitsa', slug: 'berkovitsa', population: 13253 },
  { name: 'Samokov', slug: 'samokov', population: 25688 },
  { name: 'Petrich', slug: 'petrich', population: 29060 },
  { name: 'Sandanski', slug: 'sandanski', population: 23091 },
  { name: 'Bansko', slug: 'bansko', population: 9065 },
  { name: 'Gotse Delchev', slug: 'gotse-delchev', population: 23573 },
  { name: 'Harmanli', slug: 'harmanli', population: 18557 },
  { name: 'Svilengrad', slug: 'svilengrad', population: 18132 },
  { name: 'Momchilgrad', slug: 'momchilgrad', population: 7825 },
  { name: 'Krumovgrad', slug: 'krumovgrad', population: 5129 },
  { name: 'Zlatograd', slug: 'zlatograd', population: 7110 },
  { name: 'Smolyan', slug: 'smolyan', population: 30283 },
  { name: 'Devin', slug: 'devin', population: 7054 },
  { name: 'Chepelare', slug: 'chepelare', population: 5412 },
  { name: 'Banite', slug: 'banite', population: 2957 },
  { name: 'Madan', slug: 'madan', population: 5253 },
  { name: 'Rudozem', slug: 'rudozem', population: 4780 },
  { name: 'Nedelino', slug: 'nedelino', population: 4109 },
  { name: 'Dospat', slug: 'dospat', population: 2663 },
  { name: 'Batak', slug: 'batak', population: 3498 },
  { name: 'Rakitovo', slug: 'rakitovo', population: 8543 },
  { name: 'Belovo', slug: 'belovo', population: 8688 },
  { name: 'Kostenets', slug: 'kostenets', population: 7479 },
  { name: 'Dolna Banya', slug: 'dolna-banya', population: 3230 },
  { name: 'Ihtiman', slug: 'ihtiman', population: 13757 },
  { name: 'Koprivshtitsa', slug: 'koprivshtitsa', population: 2434 },
  { name: 'Pirdop', slug: 'pirdop', population: 8681 },
  { name: 'Zlatitsa', slug: 'zlatitsa', population: 6011 },
  { name: 'Mirkovo', slug: 'mirkovo', population: 3303 },
  { name: 'Chelopech', slug: 'chelopech', population: 2788 },
  { name: 'Elin Pelin', slug: 'elin-pelin', population: 10032 },
  { name: 'Kostenets', slug: 'kostenets-alt', population: 7479 },
  { name: 'Godech', slug: 'godech', population: 4245 },
  { name: 'Svoge', slug: 'svoge', population: 8876 },
  { name: 'Etropole', slug: 'etropole', population: 10804 },
  { name: 'Pravets', slug: 'pravets', population: 4512 },
  { name: 'Botevgrad', slug: 'botevgrad', population: 20049 },
  { name: 'Lukovit', slug: 'lukovit', population: 9630 },
  { name: 'Teteven', slug: 'teteven', population: 9934 },
  { name: 'Troyan', slug: 'troyan', population: 21997 },
  { name: 'Apriltsi', slug: 'apriltsi', population: 3318 },
  { name: 'Ugarchin', slug: 'ugarchin', population: 3724 },
  { name: 'Roman', slug: 'roman', population: 3287 },
  { name: 'Yablanitsa', slug: 'yablanitsa', population: 2910 },
  { name: 'Sevlievo', slug: 'sevlievo', population: 25818 }
];

export const bulgariaExpanded = {
  code: 'BG',
  name: 'Bulgaria',
  slug: 'bulgaria',
  population: 6948445,
  topCities: [
    { name: 'Sofia', slug: 'sofia', population: 1431876 },
    ...bulgariaAdditionalCities
  ]
};
